
  var _styles = {
  "hotel-comparison": {
    "display": "flex",
    "flexDirection": "column",
    "height": "100%",
    "backgroundColor": "rgb(248,248,248)"
  },
  "hotel-comparison__scroll": {
    "flex": 1,
    "backgroundColor": "rgb(244,244,244)"
  },
  "hotel-comparison__section": {
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0
  },
  "hotel-comparison__section-title": {
    "fontSize": "0.37333rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "600",
    "marginTop": "0.16rem",
    "paddingTop": 0,
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.32rem",
    "paddingLeft": "0.42667rem"
  },
  "hotel-comparison__loading": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "1.6rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "1.6rem",
    "paddingLeft": "0.42667rem",
    "textAlign": "center"
  },
  "hotel-comparison__loading_text": {
    "fontSize": "0.37333rem",
    "color": "rgb(102,102,102)"
  },
  "hotel-comparison__error": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "1.6rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "1.6rem",
    "paddingLeft": "0.42667rem",
    "textAlign": "center"
  },
  "hotel-comparison__error_text": {
    "fontSize": "0.37333rem",
    "color": "rgb(102,102,102)",
    "marginBottom": "0.32rem"
  },
  "hotel-comparison__retry": {
    "color": "rgb(255,102,0)",
    "fontWeight": "600",
    "paddingTop": "0.21333rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.21333rem",
    "paddingLeft": "0.42667rem",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgb(255,102,0)",
    "borderRadius": "0.10667rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "hotel-comparison__empty": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "1.6rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": "1.6rem",
    "paddingLeft": "0.42667rem",
    "textAlign": "center"
  },
  "hotel-comparison__empty_text": {
    "fontSize": "0.37333rem",
    "color": "rgb(153,153,153)"
  },
  "no-recommend": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "no-recommend-text": {
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  